module.exports = __webpack_public_path__ + "media/images/feature-icons/feature-icon-3-b707ecdc917c4490e7552a9c349cac22.svg";